import {UserGender} from "../../constant/user/UserGender"
import {ContentTargetVerboseDomain} from "../../domain/content/ContentTargetVerboseDomain"
import {ContentId} from "../../id/content/ContentId"
import {ContentTargetId} from "../../id/content/ContentTargetId"
import {EnvCountryId} from "../../id/env/EnvCountryId"
import {UserId} from "../../id/user/UserId"
import {EnvCountryValueObject} from "../env/EnvCountryValueObject"
import {UserValueObject} from "../user/UserValueObject"
import {ContentValueObject} from "./ContentValueObject"
import {VerboseValueObject} from "ts-protocol-extension"

/**
 * 콘텐츠 노출 대상 상세
 */
export class ContentTargetVerboseValueObject implements VerboseValueObject, ContentTargetVerboseDomain {
    /**
     * 기본키
     */
    id: ContentTargetId
    /**
     * 생성자 ID
     */
    creatorId: UserId
    /**
     * 콘텐츠 ID
     */
    contentId: ContentId
    /**
     * 국가 ID
     */
    envCountryId?: EnvCountryId
    /**
     * 성별
     */
    userGender?: UserGender
    /**
     * 출생년도 최소
     */
    userBirthYearMin?: number
    /**
     * 출생년도 최대
     */
    userBirthYearMax?: number
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 마지막 수정일
     */
    lastModifiedAt?: Date
    /**
     * 생성자 ID
     */
    creator: UserValueObject
    /**
     * 콘텐츠 ID
     */
    content: ContentValueObject
    /**
     * 국가 ID
     */
    envCountry?: EnvCountryValueObject

    constructor(o: Record<keyof ContentTargetVerboseDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.contentId = BigInt(o.contentId)
        if (o.envCountryId !== undefined && o.envCountryId !== null) {
            this.envCountryId = BigInt(o.envCountryId)
        }
        if (o.userGender !== undefined && o.userGender !== null) {
            this.userGender = o.userGender as UserGender
        }
        if (o.userBirthYearMin !== undefined && o.userBirthYearMin !== null) {
            this.userBirthYearMin = Number(o.userBirthYearMin)
        }
        if (o.userBirthYearMax !== undefined && o.userBirthYearMax !== null) {
            this.userBirthYearMax = Number(o.userBirthYearMax)
        }
        this.createdAt = new Date(o.createdAt)
        if (o.lastModifiedAt !== undefined && o.lastModifiedAt !== null) {
            this.lastModifiedAt = new Date(o.lastModifiedAt)
        }
        this.creator = new UserValueObject(o.creator)
        this.content = new ContentValueObject(o.content)
        if (o.envCountry !== undefined && o.envCountry !== null) {
            this.envCountry = new EnvCountryValueObject(o.envCountry)
        }
    }
}
